<template>
  <v-row>
    <v-col
      v-for="n in $vuetify.breakpoint.mdAndDown ? 3 : 4"
      :key="n"
      cols="12"
      sm="4"
      :md="vertical ? '12' : '4'"
      :lg="vertical ? '12' : '3'"
      :class="vertical ? 'mb-md-4' : ''"
    >
      <v-card flat class="rounded-lg">
        <v-row class="ma-0">
          <v-col cols="12" class="text-start">
            <v-skeleton-loader
              :height="
                $vuetify.breakpoint.smAndDown
                  ? 140
                  : $vuetify.breakpoint.lgAndUp
                  ? 180
                  : 140
              "
              type="image"
              class="rounded-lg"
            />
          </v-col>

          <v-col class="pt-0 align-self-center">
            <v-skeleton-loader height="12" type="text" class="mb-2" />

            <v-skeleton-loader height="12" type="text" class="mb-6" />

            <div class="d-flex flex-row justify-space-between">
              <div>
                <v-skeleton-loader
                  width="60"
                  height="12"
                  type="text"
                  class="mb-2"
                />

                <v-skeleton-loader width="100" height="12" type="text" />
              </div>

              <div class="align-self-end">
                <v-skeleton-loader width="20" height="12" type="text" />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
